import {
  AssessmentFieldSchema,
  AssessmentResponseSchema,
  ReturnAssessmentSchema,
} from "@redotech/redo-model/return-assessments/assessment-schemas";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const ReturnProductAssessmentSchema = z.object({
  assessmentDefinition: ReturnAssessmentSchema.extend({
    definitionId: zExt.objectId(),
    fields: z.array(AssessmentFieldSchema),
  }),
  assignee: zExt.objectId().nullish(),
  completedAt: z.date().nullish(),
  responses: z.array(AssessmentResponseSchema),
});

export type ReturnProductAssessment = z.infer<
  typeof ReturnProductAssessmentSchema
>;

export const getReturnProductAssessments = unaryRpc({
  name: "getReturnProductAssessments",
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    assessments: z.record(z.string(), z.array(ReturnProductAssessmentSchema)),
  }),
});
